<template>
  <VaModal
    v-model="showModal"
    size="small"
    max-width="380px"
    :title="title"
    :message="message"
    :ok-text="okText"
    :cancel-text="cancelText"
    mobile-fullscreen
    close-button
    no-outside-dismiss
    no-esc-dismiss
    @ok="confirm(true)"
    @cancel="confirm(false)"
  >
  </VaModal>
</template>

<script setup lang="ts">
import { ref } from "vue"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const showModal = ref(false)
let resolvePromise: ((value: boolean) => void) | null = null

const title = t("general.warning")
const message = t("general.messages.formUnsavedChanges")
const okText = t("general.leave")
const cancelText = t("general.cancel")

const show = (): Promise<boolean> => {
  showModal.value = true
  return new Promise((resolve) => {
    resolvePromise = resolve
  })
}

const confirm = (result: boolean) => {
  showModal.value = false
  if (resolvePromise) {
    resolvePromise(result)
    resolvePromise = null
  }
}

defineExpose({ show })
</script>
